export default {
  getURL: 'appContentCatalog',
  createURL: 'appId/areaId/appContentPlayFromCatalog',
  sessionParams: ['appId', 'areaId'],
  loadPage:'appId/areaId/appContentPlay?page=last',
  canEdit: false,
  canOpen: false,
  isMultiSelectable: true,
  fields: [
    {
      attributeName: 'name',
      helpText: 'Title of the video.',
      label: 'Name',
      canFilter: true,
    },
    {
      attributeName: 'app',
      helpText: 'The video belongs to APP.',
      label: 'App',
      canFilter: true,
    },
    {
      attributeName: 'config',
      helpText: 'The video belongs to area.',
      label: 'App config',
      canFilter: true,
    },
  ],
};
